import DiamondIcon from '../assets/graphics/png/icons/assets/icon_currency_diamond@2x.png';
import JCoinIcon from '../assets/graphics/png/icons/assets/J_Coin@2x.png';
import CreationStaminaIcon from '../assets/graphics/png/icons/assets/rewards_icon_creation_stamina_2x.png';
import CreationTokenIcon from '../assets/graphics/png/icons/assets/rewards_icon_creation_token_2x.png';
import GameStaminaIcon from '../assets/graphics/png/icons/assets/rewards_icon_game_stamina_2x.png';
import GameTokenIcon from '../assets/graphics/png/icons/assets/rewards_icon_game_token_2x.png';
import NoticeIcon from '../assets/graphics/png/icons/cloud_icon_notice_line_2x.png';
import GameSwapIcon from '../assets/graphics/png/icons/Game_swap_line_2x.png';
import KnowledgeXPIcon from '../assets/graphics/png/icons/assets/cloud_icon_knowledge_2x.png';
import SocialXPIcon from '../assets/graphics/png/icons/assets/cloud_icon_social_2x.png';

export const pngIcons = {
  // assets
  JCoin: JCoinIcon,
  CreationToken: CreationTokenIcon,
  GameToken: GameTokenIcon,
  Diamond: DiamondIcon,
  CreationStamina: CreationStaminaIcon,
  GameStamina: GameStaminaIcon,
  KnowledgeXP: KnowledgeXPIcon,
  SocialXP: SocialXPIcon,
  //
  GameSwap: GameSwapIcon,
  Notice: NoticeIcon,
};

export type PNGIconName = keyof typeof pngIcons;
